export default "__VITE_ASSET__ReW$vnmi__"